// What Open the till says the last cash-off left in the drawer, and when. "Last night" only
// for a close in the evening before, or after midnight this morning: a lunch cash-off two
// hours ago, or one at ten yesterday morning, is not last night (review of #297). A close with
// no figure (one from before cash-offs carried a float) says nothing, rather than £0.00.
const NIGHT_FROM = 17;   // a close from five in the evening …
const NIGHT_TO = 6;      // … to six the next morning is "last night"

const clock = (d) => d.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' });
const day = (d) => d.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short' });

export function carriedWords(last, money, now = new Date()) {
  if (typeof last?.float_carried !== 'number') return '';
  const carried = money(last.float_carried);
  const closed = last.closed_at ? new Date(last.closed_at) : null;
  if (!closed || Number.isNaN(closed.getTime())) return `The last cash-off carried ${carried}.`;
  const yesterday = new Date(now);
  yesterday.setDate(now.getDate() - 1);
  const today = closed.toDateString() === now.toDateString();
  const lastEvening = closed.toDateString() === yesterday.toDateString();
  const hour = closed.getHours();
  if ((lastEvening && hour >= NIGHT_FROM) || (today && hour < NIGHT_TO)) return `Last night carried ${carried}.`;
  if (today) return `The cash-off at ${clock(closed)} carried ${carried}.`;
  if (lastEvening) return `Yesterday's cash-off at ${clock(closed)} carried ${carried}.`;
  return `The last cash-off, on ${day(closed)}, carried ${carried}.`;
}
